import { formatDateStringRangeWithLocalTimeZone } from "@/lib/dates/formatters";
import { Space } from "@stenajs-webui/core";
import {
  Card,
  CardBody,
  CardHeader,
  stenaIntermodal,
} from "@stenajs-webui/elements";
import * as React from "react";
import { HeadAgreementStatusCodeChip } from "@/components/chips/HeadAgreementStatusCodeChip";
import { InfoBoxItem } from "../InfoBoxItem";
import { MultiLegAgreementBox } from "../types";
import { MultiLegAgreementInfoPairPopover } from "./MultiLegAgreementInfoPairPopover";

interface Props {
  multiLegAgreement: MultiLegAgreementBox;
}

export const MultiLegAgreementInfoPairBox: React.FC<Props> = ({
  multiLegAgreement,
}) => {
  return (
    <Card>
      <CardHeader
        variant={"compact"}
        text={"Multi leg agreement"}
        leftIcon={stenaIntermodal}
        contentRight={
          <MultiLegAgreementInfoPairPopover
            mutliLegAgreement={multiLegAgreement}
          />
        }
      />
      <CardBody flexDirection={"row"} flexWrap={"wrap"} variant={"compact"}>
        <HeadAgreementStatusCodeChip
          statusCode={multiLegAgreement.statusCode}
          size={"small"}
          key={"head-agreement-infobox-key-0"}
        />
        <Space />
        <InfoBoxItem
          leftContent={"Validity"}
          rightContent={formatDateStringRangeWithLocalTimeZone({
            dateStringFrom: multiLegAgreement.valid.start?.isoString,
            dateStringTo: multiLegAgreement.valid.end?.isoString,
          })}
          key={"head-agreement-infobox-key-1"}
        />
        <InfoBoxItem
          leftContent={"Route"}
          rightContent={multiLegAgreement.route.code}
          key={"head-agreement-infobox-key-2"}
        />
      </CardBody>
    </Card>
  );
};
